// removed by extract-text-webpack-plugin
module.exports = {"balloon":"TipBalloon_balloon_1IT","arrow":"TipBalloon_arrow_3yK"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/TipBalloon/TipBalloon.css
 ** module id = 578
 ** module chunks = 0
 **/